import { api } from './api';
import type { LegalBasis as SharedLegalBasis } from '@safetyhub/shared';
export type { LegalBasis } from '@safetyhub/shared';
type LegalBasis = SharedLegalBasis;

export interface Measure {
  id: string;
  category: string;
  subCategory: string | null;
  measure: string;
  source: 'AI' | 'USER' | 'SYSTEM';
  usageCount: number;
  // legalBases removed - regulations stored in RegulationKnowledgeLink
  confidence: number | null;
}

export interface GroupedMeasures {
  category: string;
  subCategory: string | null;
  measures: Measure[];
}

export interface SearchMeasuresParams {
  search?: string;
  category?: string;
  subCategory?: string;
  limit?: number;
}

/**
 * 개선 대책 검색 (자동완성용)
 */
export async function searchMeasures(
  companyId: string,
  params: SearchMeasuresParams = {},
): Promise<GroupedMeasures[]> {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.set('search', params.search);
  if (params.category) queryParams.set('category', params.category);
  if (params.subCategory) queryParams.set('subCategory', params.subCategory);
  if (params.limit) queryParams.set('limit', String(params.limit));

  const response = await api.get(
    `/organizations/${companyId}/knowledge?${queryParams}`,
  );
  return response.data.data;
}

/**
 * 카테고리 목록 조회
 */
export async function getMeasureCategories(
  companyId: string,
): Promise<string[]> {
  const response = await api.get(
    `/organizations/${companyId}/knowledge/categories`,
  );
  return response.data.data;
}

/**
 * 중주제 목록 조회
 */
export async function getMeasureSubCategories(
  companyId: string,
  category: string,
): Promise<string[]> {
  const response = await api.get(
    `/organizations/${companyId}/knowledge/sub-categories?category=${encodeURIComponent(category)}`,
  );
  return response.data.data;
}

/**
 * 인기 대책 조회
 */
export async function getPopularMeasures(
  companyId: string,
  limit: number = 10,
): Promise<Measure[]> {
  const response = await api.get(
    `/organizations/${companyId}/knowledge/popular?limit=${limit}`,
  );
  return response.data.data;
}

/**
 * 사용 횟수 증가
 */
export async function incrementMeasureUsage(
  companyId: string,
  measureId: string,
): Promise<void> {
  await api.post(`/organizations/${companyId}/knowledge/${measureId}/usage`);
}

export interface SearchLegalBasesParams {
  search?: string;
  category?: string;
  subCategory?: string;
  limit?: number;
}

/**
 * 지식베이스에서 법규 목록 검색
 */
export async function searchLegalBases(
  companyId: string,
  params: SearchLegalBasesParams = {},
): Promise<LegalBasis[]> {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.set('search', params.search);
  if (params.category) queryParams.set('category', params.category);
  if (params.subCategory) queryParams.set('subCategory', params.subCategory);
  if (params.limit) queryParams.set('limit', String(params.limit));

  const response = await api.get(
    `/organizations/${companyId}/knowledge/legal-bases?${queryParams}`,
  );
  return response.data.data;
}
